module.exports = __webpack_public_path__ + "img/contact_icon.61c2b225.png";